<template>
    <label class="radio-button">
        <input type="radio" v-model="internalBinding" :value="value" :disabled="disabled" />
        <span class="label-text">{{ label }}</span>
    </label>
</template>
<script>
export default {
    name: 'RadioButton',
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        modelValue: {
            required: false,
        },
        value: {
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        internalBinding: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            },
        },
    },
}
</script>
